import React from 'react';

function Terms() {
  return <div className='container p-4 card mt-4'>Terms</div>;
}

export default Terms;
